export var Roles;
(function (Roles) {
    Roles["OWNER"] = "Owner";
    Roles["DEFAULT"] = "Default";
})(Roles || (Roles = {}));
